import { render } from "./UserLayout.vue?vue&type=template&id=57a5cdeb&scoped=true"
const script = {}

import "./UserLayout.vue?vue&type=style&index=0&id=57a5cdeb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a5cdeb"]])

export default __exports__